import { useEffect, useRef } from 'react';

import styles from '../../styles/modules/game/Game.module.scss';

import titleImg from '../../assets/images/game/title.webp';
import hintImg from '../../assets/images/game/game_img.webp';

import GameFeeds from './GameFeeds';

import { useAnimation } from '../../hooks/useAnimation';
import { useGameStore } from '../../store/useGameStore';

const PLAYER_ANIMATIONS = {
	1: 'attack_up',
	2: 'attack_center',
	3: 'attack_down',
};

const Game = () => {
	const playerRef = useRef(null);

	const { animation, switchAnimation } = useGameStore();

	const player = useAnimation({
		ref: playerRef,
		name: 'player',
		viewport: {
			x: -3000,
			y: -3500,
			width: 2000 * 1.7,
			height: 5000 * 1.7,
			padLeft: '0%',
			padRight: '0%',
			padTop: '0%',
			padBottom: '0%',
		},
	});

	useEffect(() => {
		if (!player) return;

		let timerId = null;

		if (animation) {
			player.setAnimation(PLAYER_ANIMATIONS[animation]);

			timerId = setTimeout(() => {
				switchAnimation(null);
				player.setAnimation('idle');

				if (timerId) clearTimeout(timerId);
			}, 700);
		}

		return () => {
			if (timerId) clearTimeout(timerId);
		};
	}, [animation, switchAnimation, player]);

	return (
		<div className={styles.section}>
			<div className={styles.content}>
				<div className={styles.game}>
					<div className={styles.titles}>
						<img src={titleImg} alt='' />
					</div>

					<div className={styles.area}>
						<div className={styles.hint}>
							<img src={hintImg} alt='' />
						</div>

						<div className={styles.bridge} />

						<div className={styles.player}>
							<div className='player-container' id='player-container' ref={playerRef} />
						</div>

						<GameFeeds />
					</div>
				</div>
			</div>
		</div>
	);
};

export default Game;
